import { EFEMALE_SIZES, EFEMALE_UNISEX_SIZES, EMALE_SIZES, EMALE_UNISEX_SIZES } from "../constants/shoe-sizes";

export const mappedMaleUnisexSizes : { [ key in EMALE_UNISEX_SIZES ] : string } = {
    [ EMALE_UNISEX_SIZES.UNISEX_MALE_4 ] : "Male Unisex 4",
    [ EMALE_UNISEX_SIZES.UNISEX_MALE_5 ] : "Male Unisex 5",
    [ EMALE_UNISEX_SIZES.UNISEX_MALE_6 ] : "Male Unisex 6",
    [ EMALE_UNISEX_SIZES["UNISEX_MALE_6.5"] ] : "Male Unisex 6.5",
    [ EMALE_UNISEX_SIZES.UNISEX_MALE_7 ] : "Male Unisex 7",
    [ EMALE_UNISEX_SIZES["UNISEX_MALE_7.5"] ] : "Male Unisex 7.5",
    [ EMALE_UNISEX_SIZES.UNISEX_MALE_8 ] : "Male Unisex 8",
    [ EMALE_UNISEX_SIZES["UNISEX_MALE_8.5"] ] : "Male Unisex 8.5",
    [ EMALE_UNISEX_SIZES.UNISEX_MALE_9 ] : "Male Unisex 9",
    [ EMALE_UNISEX_SIZES["UNISEX_MALE_9.5"] ] : "Male Unisex 9.5",
    [ EMALE_UNISEX_SIZES.UNISEX_MALE_10 ] : "Male Unisex 10",
    [ EMALE_UNISEX_SIZES["UNISEX_MALE_10.5"] ] : "Male Unisex 10.5",
    [ EMALE_UNISEX_SIZES.UNISEX_MALE_11 ] : "Male Unisex 11",
    [ EMALE_UNISEX_SIZES["UNISEX_MALE_11.5"] ] : "Male Unisex 11.5",
    [ EMALE_UNISEX_SIZES.UNISEX_MALE_12 ] : "Male Unisex 12",
    [ EMALE_UNISEX_SIZES.UNISEX_MALE_13 ] : "Male Unisex 13",
    [ EMALE_UNISEX_SIZES.UNISEX_MALE_14 ] : "Male Unisex 14",
}

export const mappedMaleSizes : { [ key in EMALE_SIZES ] : string } = {
    [ EMALE_SIZES.MALE_6 ] : "Male 6",
    [ EMALE_SIZES["MALE_6.5"] ] : "Male 6.5",
    [ EMALE_SIZES.MALE_7 ] : "Male 7",
    [ EMALE_SIZES["MALE_7.5"] ] : "Male 7.5",
    [ EMALE_SIZES.MALE_8 ] : "Male 8",
    [ EMALE_SIZES["MALE_8.5"] ] : "Male 8.5",
    [ EMALE_SIZES.MALE_9 ] : "Male 9",
    [ EMALE_SIZES["MALE_9.5"] ] : "Male 9.5",
    [ EMALE_SIZES.MALE_10 ] : "Male 10",
    [ EMALE_SIZES["MALE_10.5"] ] : "Male 10.5",
    [ EMALE_SIZES.MALE_11 ] : "Male 11",
    [ EMALE_SIZES["MALE_11.5"] ] : "Male 11.5",
    [ EMALE_SIZES.MALE_12 ] : "Male 12",
    [ EMALE_SIZES.MALE_13 ] : "Male 13",
    [ EMALE_SIZES.MALE_14 ] : "Male 14",
    [ EMALE_SIZES.MALE_15 ] : "Male 15",
    [ EMALE_SIZES.MALE_16 ] : "Male 16",
}

export const mappedFemaleUnisexSizes : { [ key in EFEMALE_UNISEX_SIZES ] : string } = {
    [ EFEMALE_UNISEX_SIZES.UNISEX_FEMALE_6 ] : "Female Unisex 6",
    [ EFEMALE_UNISEX_SIZES.UNISEX_FEMALE_7 ] : "Female Unisex 7",
    [ EFEMALE_UNISEX_SIZES.UNISEX_FEMALE_8 ] : "Female Unisex 8",
    [ EFEMALE_UNISEX_SIZES["UNISEX_FEMALE_8.5"] ] : "Female Unisex 8.5",
    [ EFEMALE_UNISEX_SIZES.UNISEX_FEMALE_9 ] : "Female Unisex 9",
    [ EFEMALE_UNISEX_SIZES["UNISEX_FEMALE_9.5"] ] : "Female Unisex 9.5",
    [ EFEMALE_UNISEX_SIZES.UNISEX_FEMALE_10 ] : "Female Unisex 10",
    [ EFEMALE_UNISEX_SIZES["UNISEX_FEMALE_10.5"] ] : "Female Unisex 10.5",
    [ EFEMALE_UNISEX_SIZES.UNISEX_FEMALE_11 ] : "Female Unisex 11",
    [ EFEMALE_UNISEX_SIZES["UNISEX_FEMALE_11.5"] ] : "Female Unisex 11.5",
    [ EFEMALE_UNISEX_SIZES.UNISEX_FEMALE_12 ] : "Female Unisex 12",
    [ EFEMALE_UNISEX_SIZES["UNISEX_FEMALE_12.5"] ] : "Female Unisex 12.5",
    [ EFEMALE_UNISEX_SIZES.UNISEX_FEMALE_13 ] : "Female Unisex 13",
    [ EFEMALE_UNISEX_SIZES["UNISEX_FEMALE_13.5"] ] : "Female Unisex 12.5",
    [ EFEMALE_UNISEX_SIZES.UNISEX_FEMALE_14 ] : "Female Unisex 14",
}

export const mappedFemaleSizes : { [ key in EFEMALE_SIZES ] : string } = {
    [ EFEMALE_SIZES.FEMALE_4 ] : "Female 4",
    [ EFEMALE_SIZES["FEMALE_4.5"]] : "Female 4.5",
    [ EFEMALE_SIZES.FEMALE_5 ] : "Female 5",
    [ EFEMALE_SIZES["FEMALE_5.5"]] : "Female 5.5",
    [ EFEMALE_SIZES.FEMALE_6 ] : "Female 6",
    [ EFEMALE_SIZES["FEMALE_6.5"] ] : "Female 6.5",
    [ EFEMALE_SIZES.FEMALE_7 ] : "Female 7",
    [ EFEMALE_SIZES["FEMALE_7.5"] ] : "Female 7.5",
    [ EFEMALE_SIZES.FEMALE_8 ] : "Female 8",
    [ EFEMALE_SIZES["FEMALE_8.5"] ] : "Female 8.5",
    [ EFEMALE_SIZES.FEMALE_9 ] : "Female 9",
    [ EFEMALE_SIZES["FEMALE_9.5"] ] : "Female 9.5",
    [ EFEMALE_SIZES.FEMALE_10 ] : "Female 10",
    [ EFEMALE_SIZES["FEMALE_10.5"] ] : "Female 10.5",
    [ EFEMALE_SIZES.FEMALE_11 ] : "Female 11",
    [ EFEMALE_SIZES["FEMALE_11.5"] ] : "Female 11.5",
    [ EFEMALE_SIZES.FEMALE_12 ] : "Female 12",
}

export type EShoeSizes = EFEMALE_SIZES & EFEMALE_UNISEX_SIZES & EMALE_SIZES & EMALE_UNISEX_SIZES;

export const mappedShoeSizes : { [key in EShoeSizes] : string } = {
    ...mappedMaleSizes,
    ...mappedMaleUnisexSizes,
    ...mappedFemaleSizes,
    ...mappedFemaleUnisexSizes,
};
